module.exports = __webpack_public_path__ + "img/P150T_weapon_119.5e4a7eb6.png";